<template>
    <li>
        <a :class="classIsActive" @click="setActiveStep(stepName)">
            <span>{{ stepText }}</span>
            <span v-if="isComplete" class="icon has-text-success">
                <i class="fa fa-check" />
            </span>
        </a>
    </li>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "step",
        props: ["stepName", "stepText", "isComplete"],
        computed: {
            ...mapState("main", ["activeStep"]),
            classIsActive() {
                return this.activeStep === this.stepName ? "is-active" : "";
            },
        },
        methods: {
            setActiveStep(step) {
                this.$store.commit("main/setActiveStep", step);
            },
        },
    };
</script>

<style scoped></style>
